"use strict";
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const single_sign_on_client_1 = require("@dcl/single-sign-on-client");
const constants_1 = require("decentraland-dapps/dist/containers/Navbar/constants");
const useNotifications_1 = __importDefault(require("decentraland-dapps/dist/hooks/useNotifications"));
const Footer_1 = require("decentraland-ui/dist/components/Footer/Footer");
const config_1 = require("decentraland-ui2/dist/config");
const decentraland_ui2_1 = require("decentraland-ui2");
const useAuthContext_1 = __importDefault(require("../../context/Auth/useAuthContext"));
const useProfileContext_1 = __importDefault(require("../../context/Auth/useProfileContext"));
const utils_1 = require("../../context/Auth/utils");
const FeatureFlag_1 = require("../../context/FeatureFlag");
const types_1 = require("../../context/FeatureFlag/types");
const useShareContext_1 = __importDefault(require("../../context/Share/useShareContext"));
const useTrackLinkContext_1 = __importDefault(require("../../context/Track/useTrackLinkContext"));
const useAsyncState_1 = __importDefault(require("../../hooks/useAsyncState"));
const useChainId_1 = __importDefault(require("../../hooks/useChainId"));
const utils_2 = require("../../plugins/intl/utils");
const segment_1 = __importDefault(require("../../utils/development/segment"));
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const manaBalance_1 = require("../../utils/loader/manaBalance");
const trackEvent_1 = __importDefault(require("../../utils/segment/trackEvent"));
const ShareModal_1 = __importDefault(require("../Modal/ShareModal"));
const WrongNetworkModal_1 = __importDefault(require("../Modal/WrongNetworkModal"));
const Avatar_1 = __importDefault(require("../Profile/Avatar"));
require("./Layout2.css");
function Layout2({ children, pageContext, hideNavbar, hideFooter, hideDownloadButton, ...props }) {
    var _a, _b;
    const locale = ((_a = pageContext === null || pageContext === void 0 ? void 0 : pageContext.intl) === null || _a === void 0 ? void 0 : _a.locale) || 'en';
    const locales = ((_b = pageContext === null || pageContext === void 0 ? void 0 : pageContext.intl) === null || _b === void 0 ? void 0 : _b.locales) || ['en'];
    const [ff] = (0, FeatureFlag_1.useFeatureFlagContext)();
    const [user, userState] = (0, useAuthContext_1.default)();
    const [, shareState] = (0, useShareContext_1.default)();
    const identity = (0, react_1.useMemo)(() => {
        var _a;
        if (user) {
            return (_a = (0, single_sign_on_client_1.localStorageGetIdentity)(user)) !== null && _a !== void 0 ? _a : undefined;
        }
        return undefined;
    }, [user]);
    const { isModalOpen, isNotificationsOnboarding, modalActiveTab, isLoading, notifications, handleNotificationsOpen, handleOnBegin, handleOnChangeModalTab, } = (0, useNotifications_1.default)(identity, true);
    const notificationProps = (0, react_1.useMemo)(() => ({
        locale: locale,
        isLoading,
        isOnboarding: isNotificationsOnboarding,
        isOpen: isModalOpen,
        items: notifications,
        activeTab: modalActiveTab,
        identity,
        onClick: handleNotificationsOpen,
        onClose: handleNotificationsOpen,
        onBegin: handleOnBegin,
        onChangeTab: (_, tab) => handleOnChangeModalTab(tab),
        renderProfile: (address) => (react_1.default.createElement("div", { className: "layout__notifications-profile" },
            react_1.default.createElement(Avatar_1.default, { address: address, size: "tiny" }),
            ' ',
            decentraland_ui2_1.dclAddressUtils.shorten(address))),
    }), [
        locale,
        isLoading,
        isNotificationsOnboarding,
        isModalOpen,
        notifications,
        modalActiveTab,
        handleNotificationsOpen,
        handleNotificationsOpen,
        handleOnBegin,
        handleOnChangeModalTab,
    ]);
    const handleChangeLocal = function (_, data) {
        (0, utils_2.changeLocale)(data.value);
    };
    const handleClickUserMenuOption = (0, useTrackLinkContext_1.default)(function (event, options) {
        event.preventDefault();
        (0, segment_1.default)((analytics) => {
            analytics.track(constants_1.DROPDOWN_MENU_ITEM_CLICK_EVENT, options);
        });
        if (props.onClickUserMenuItem) {
            props.onClickUserMenuItem(event, options);
        }
        return null;
    }, [props.onClickUserMenuItem]);
    const handleClickDownload = (0, react_1.useCallback)(function (event, options) {
        event.preventDefault();
        (0, segment_1.default)((analytics) => {
            analytics.track(constants_1.NAVBAR_DOWNLOAD_EVENT, {
                ...options,
                place: constants_1.NAVBAR_DOWNLOAD_EVENT_PLACE,
            });
        });
        return null;
    }, []);
    const handleClickNavbarOption = (0, useTrackLinkContext_1.default)(function (event, options) {
        (0, segment_1.default)((analytics) => {
            analytics.track('Click on Navbar', options);
        });
        if (props.onClickNavbarItem) {
            props.onClickNavbarItem(event, options);
        }
        return null;
    }, [props.onClickNavbarItem]);
    const handleSwitchNetwork = (0, react_1.useCallback)((chainId) => userState.switchTo(chainId), [userState]);
    const [profile, profileState] = (0, useProfileContext_1.default)();
    const chainId = (0, useChainId_1.default)();
    const loading = userState.loading || profileState.loading;
    const cdnLinks = ff.payload(types_1.DappsFeatureFlags.LauncherLinks, undefined);
    const [manaBalances] = (0, useAsyncState_1.default)(async () => {
        if (!user) {
            return {};
        }
        const manaBalance = await (0, manaBalance_1.fetchManaBalance)(user, chainId);
        return manaBalance;
    }, [user, chainId]);
    const handleClickBalance = (0, react_1.useCallback)((event, network) => {
        event.preventDefault();
        if (network) {
            (0, segment_1.default)((analytics) => {
                analytics.track(constants_1.DROPDOWN_MENU_BALANCE_CLICK_EVENT, { network });
            });
        }
        setTimeout(() => {
            window.open(config_1.config.get('ACCOUNT_URL'), '_blank', 'noopener');
        }, 300);
    }, []);
    const handleOpen = (0, react_1.useCallback)((e, track_uuid) => {
        (0, segment_1.default)((analytics) => {
            analytics.track(constants_1.DROPDOWN_MENU_DISPLAY_EVENT, { track_uuid });
        });
    }, []);
    const handleSignOut = (0, react_1.useCallback)((e, track_uuid) => {
        (0, segment_1.default)((analytics) => {
            analytics.track(constants_1.DROPDOWN_MENU_SIGN_OUT_EVENT, { track_uuid });
        });
        setTimeout(() => {
            userState.disconnect();
        }, 300);
    }, [userState.disconnect]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !hideNavbar && (react_1.default.createElement(decentraland_ui2_1.Navbar, { manaBalances: manaBalances, address: user || undefined, avatar: profile || undefined, activePage: props.activePage, isSignedIn: !!profile, isSigningIn: loading, onClickBalance: handleClickBalance, onClickNavbarItem: handleClickNavbarOption, onClickUserMenuItem: handleClickUserMenuOption, onClickOpen: handleOpen, onClickSignIn: userState.authorize, onClickSignOut: handleSignOut, notifications: notificationProps, onClickDownload: handleClickDownload, hideDownloadButton: hideDownloadButton, cdnLinks: cdnLinks })),
        react_1.default.createElement("main", { className: "layout__main-container" }, children),
        react_1.default.createElement(ShareModal_1.default, { data: shareState.data, onClose: shareState.close }),
        react_1.default.createElement(WrongNetworkModal_1.default, { currentNetwork: userState.chainId, isSwitching: userState.loading, expectedNetwork: (0, utils_1.getSupportedChainIds)(), onSwitchNetwork: handleSwitchNetwork, providerType: userState.providerType }),
        !hideFooter && (react_1.default.createElement(Footer_1.Footer, { locale: locale, locales: locales, isFullscreen: props.isFullscreen, className: TokenList_1.default.join([
                // TODO(#323): remove on v6 use bem notation
                'LayoutFooterContainer',
                'layout__footer',
                props.className,
            ]), i18n: props.i18n, onChange: (0, trackEvent_1.default)(handleChangeLocal), hideSocialLinks: props.hideSocialLinks }))));
}
exports.default = Layout2;
